import { IFile } from '../global/file';

export interface IStatus {
  id: number;
  oldStatus: string;
  newStatus: string;
}

export interface IInvoice {
  id: number;
  organizationId: number;
  organizationName: string;
  created: string;
  sent: string;
  formattedAddress: string;
  email: string;
  dueDate: string;
  pdfFileId: number;
  excelFileId: number
  pdfFile: IFile;
  excelFile: IFile;
  status: string;
  periodFrom: string;
  periodTo: string;
  currencyCode: string;
  type: string;
  invoiceNumber: string;
  statusUpdates: IStatus[];
}

export enum InvoiceStatusType {
  Created = 'CREATED',
  Approved = 'APPROVED',
  Blocked = 'BLOCKED',
  Sent = 'SENT',
  Paid = 'PAID',
  WrittenOff = 'WRITTEN_OFF',
  Error = 'ERROR',
  Pending = 'PENDING',
  Overdue = 'OVERDUE',
}

export const InvoiceStatusDisplayName = {
  [InvoiceStatusType.Created]: 'Created',
  [InvoiceStatusType.Approved]: 'Approved',
  [InvoiceStatusType.Blocked]: 'Blocked',
  [InvoiceStatusType.Sent]: 'Sent',
  [InvoiceStatusType.Paid]: 'Paid',
  [InvoiceStatusType.WrittenOff]: 'Written off',
  [InvoiceStatusType.Error]: 'Error',
  [InvoiceStatusType.Pending]: 'Pending',
  [InvoiceStatusType.Overdue]: 'Overdue',
};

export enum InvoiceType {
  Partner = 'PARTNER',
  TransferCompany = 'TRANSFER_COMPANY'
}

export const InvoiceTypeDisplayName = {
  [InvoiceType.Partner]: 'Partner',
  [InvoiceType.TransferCompany]: 'Transfer company',
};
